import { Log } from '@yoummday/ymmd-logger';
import '@yoummday/ymmd-platform-core/comp/app-link';
import { getAppElement } from '@yoummday/ymmd-platform-core/comp/app-shell';
import '@yoummday/ymmd-shoelace/dist/shoelace.js';
import { render } from 'lit';
import { API } from './api';
import './components/app';
import { i18n } from './i18n';
import { User } from './User';

const init = async () => {
	// @ts-expect-error - /whoami endpoint is not typed
	const { data } = await API.GET('/whoami');
	const { user } = data ?? { user: null };
	if (user) User.updateUser(user);
	await i18n.setLanguage(User.user?.lang || User.preferredLanguage || 'en');

	return getAppElement() ? null : document.createElement('backoffice-billing');
};

init()
	.then((app) => {
		if (app) render(app, document.body);
	})
	.catch((err) => {
		Log.error(err);
	});
